import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as SelfServeBuilderActions from 'SelfServeBuilder/SelfServeBuilderActions';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import { PrimaryButton, DarkSecondaryButton } from 'DesignSystem/Buttons';
import ZeroStateModalIcon from './ZeroStateModalIcon';

export class ZeroStateModalBody extends React.PureComponent {
  static uploadTracking() {
    window._track('Upload | Upload Page', 'Template Builder');
  }

  constructor(props) {
    super(props);

    this.onClickDemoButton = this.onClickDemoButton.bind(this);
  }

  componentDidMount() {
    window.Upload.activateUploadButtonById(
      'selfServeZeroStateUpload',
      'custom-template',
      `${window.API_URL}/custom-template`,
      false,
    );
  }

  onClickDemoButton() {
    window._track('Try a Demo | Upload Page', 'Template Builder');
    this.props.createSampleDocument(
      SelfServeBuilderEnum.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT,
    );
  }

  render() {
    return (
      <div className="self-serve-zero-state-modal-body">
        <div className="zero-state-modal-icons">
          <ZeroStateModalIcon
            heading="Add fillable fields"
            imagePath="images/self-serve-builder/modals/zero-state-icons/step-1-2x.png"
            number={1}
          />
          <ZeroStateModalIcon
            heading="Recipients answer easy questions"
            imagePath="images/self-serve-builder/modals/zero-state-icons/step-2-2x.png"
            number={2}
          />
          <ZeroStateModalIcon
            heading="Get documents back error-free"
            hideArrow
            imagePath="images/self-serve-builder/modals/zero-state-icons/step-3-2x.png"
            number={3}
          />
        </div>
        <div
          className="zero-state-buttons-wrapper"
        >
          <DarkSecondaryButton onClick={this.onClickDemoButton}>
            Try a Demo
          </DarkSecondaryButton>
          <div
            className="upload-button-wrap"
            id="selfServeZeroStateUpload"
            onClick={ZeroStateModalBody.uploadTracking}
          >
            <PrimaryButton>
              Upload Your Document
            </PrimaryButton>
            <div className="upload-details-wrapper">
              <p>PDF or Microsoft Word</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


ZeroStateModalBody.propTypes = {
  createSampleDocument: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    createSampleDocument: SelfServeBuilderActions.createSampleDocument,
  }, dispatch)
);

export const ZeroStateModalBodyWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(ZeroStateModalBody);

export default ZeroStateModalBodyWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/ZeroStateModalBody.jsx